import * as CommonAction from './action';
const initialState = {
    fetchComments: [],
    postComments: [],
    readCommentStatus: [],
    readCommentStatusFailure: [],
    aggregateTypes: [],
    aggregateTypesFailure: [],
    aggregateDirections: [],
    aggregateDirectionsFailure: [],
    dataTypes: [],
    dataTypesFailure: [],
    riskLevels: [],
    riskLevelsError: [],
    countrySuccess: [],
    countryFailure: [],
    stateListSuccess: [],
    stateListFailure: [],
    corporateSuccess: '',
    corporateFailure: []
}
const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case CommonAction.FETCH_COMMENTS_SUCCESS:
            return state = {
                ...state,
                fetchComments: action.data
            }
        case CommonAction.FETCH_COMMENTS_FAILURE:
            return state = {
                ...state,
                fetchComments: action
            }
        case CommonAction.POST_COMMENTS_SUCCESS:
            return state = {
                ...state,
                postComments: action.data
            }
        case CommonAction.POST_COMMENTS_FAILURE:
            return state = {
                ...state,
                postComments: action
            }
        case CommonAction.COMMENT_READ_STATUS_SUCCESS:
            return state = {
                ...state,
                readCommentStatus: action.data
            }
        case CommonAction.COMMENT_READ_STATUS_FAILURE:
            return state = {
                ...state,
                readCommentStatusFailure: action.data
            }
        case CommonAction.FETCH_AGGREGATE_TYPES_SUCCESS:
            return state = {
                ...state,
                aggregateTypes: action.data
            }
        case CommonAction.FETCH_AGGREGATE_TYPES_FAILURE:
            return state = {
                ...state,
                aggregateTypesFailure: action.data
            }
        case CommonAction.FETCH_AGGREGATE_DIRECTIONS_SUCCESS:
            return state = {
                ...state,
                aggregateDirections: action.data
            }
        case CommonAction.FETCH_AGGREGATE_DIRECTIONS_FAILURE:
            return state = {
                ...state,
                aggregateDirectionsFailure: action.data
            }
        case CommonAction.FETCH_DATA_TYPES_SUCCESS:
            return state = {
                ...state,
                dataTypes: action.data
            }
        case CommonAction.FETCH_DATA_TYPES_FAILURE:
            return state = {
                ...state,
                dataTypesFailure: action.data
            }
        case CommonAction.FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS:
            return state = {
                ...state,
                riskLevels: action.data
            }
        case CommonAction.FETCH_RISKGRADE_CATEGORY_LIST_FAILURE:
            return state = {
                ...state,
                riskLevelsError: action.error
            }
        case CommonAction.GET_SELECTED_COUNTRY_STATES_SUCCESS:
            return state = {
                ...state,
                stateListSuccess: action.data
            }
        case CommonAction.GET_SELECTED_COUNTRY_STATES_FAILURE:
            return state = {
                ...state,
                stateListFailure: action.data
            }
        case CommonAction.FETCH_CORPORATE_DETAILS_SUCCESS:
            return state = {
                ...state,
                corporateSuccess: action.data
            }
        case CommonAction.FETCH_CORPORATE_DETAILS_FAILURE:
            return state = {
                ...state,
                corporateFailure: action.data
            }
        default: return state
    }
}

export default commonReducer;
